export const validCredentials = [
   
    

      { expirationDate:"Acceso Ilimitado",nivel:"premium",usuario: 'carlos', password: 'app', realname: 'Prueba Gratuita', img: 'https://i.ibb.co/chn6rvR/Dise-o-sin-t-tulo-3.png' }, // No image

    
  

       {  expirationDate:"2026",nivel:"solicitar examen",usuario: 'udemy25', password: 'b2c1', realname: 'Estudiante Autodidacta', img: 'https://i.ibb.co/chn6rvR/Dise-o-sin-t-tulo-3.png' }, // No image
       {  expirationDate:"2026",nivel:"solicitar examen",usuario: 'udemy25', password: 'a1a2', realname: 'Estudiante Autodidacta', img: 'https://i.ibb.co/chn6rvR/Dise-o-sin-t-tulo-3.png' }, // No image
    


     
  


     { expirationDate:"2026",nivel:"B2",usuario: 'udemy', password: 'myenglishbro', realname: 'My English Bro!',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
   








      { expirationDate:"Unlimited",nivel:"c1",usuario: 'mafer', password: 'vilchez', realname: 'Mafer Vilchez', img: 'https://i.ibb.co/jv0jDGgs/Chat-GPT-Image-6-jul-2025-13-23-34.png' }, // No image


//ACCESO DE POR VIDA
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'adrian', password: 'aliaga', realname: 'Adrian Aliaga',img:'https://i.ibb.co/DHQLnHbK/ADRIAN.png'},
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'gabriela', password: 'torres', realname: 'Gabriela Torres',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'herberth', password: 'jara', realname: 'Herberth Jara Huaman',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'beatriz', password: 'cordova', realname: 'Beatriz Cordova',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'joanna', password: 'fierro', realname: 'Joanna E. Fierro',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},

             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'jhanet', password: 'villanueva', realname: 'Jhanet M.Villanueva',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
                        { expirationDate:"30 days",nivel:"B2",usuario: 'alvaro', password: 'neyra', realname: 'Alvaro Neyra',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},

                        { expirationDate:"Unlimited Account",nivel:"B1",usuario: 'katherine', password: 'mendieta', realname: 'Katherine Mendieta',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},


             //ACCESO DE POR VIDA tiktok
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'maria', password: 'ramos', realname: 'Maria C. Ramos',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
                    { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'sebastian', password: 'nunez', realname: 'Sebastian Nuñez',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},

                    { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'martha', password: 'barua', realname: 'Martha Barua',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},

             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'adrian', password: 'mendoza', realname: 'Adrian Mendoza C',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'andrea', password: 'tucno', realname: 'Andrea P. Tucno',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
             { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'anabel', password: 'guevara', realname: 'Anabel D. Guevara',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
           { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'fabricio', password: 'paltan', realname: 'Fabricio Paltan',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},
           { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'studentbro', password: 'unlimited', realname: 'English Student',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},
           { expirationDate:"Unlimited Account",nivel:"A1",usuario: 'jose', password: 'benites', realname: 'Jose benites',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},
           { expirationDate:"Unlimited Account",nivel:"A1",usuario: 'luis', password: 'zorrilla', realname: 'Luis D. Zorrilla',img:'https://i.ibb.co/ynbL39Bx/505486947-1373472863709226-49176.png'},
                    { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'sara', password: 'bonifacio', realname: 'Sara Bonifacio',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},
                    { expirationDate:"Unlimited Account",nivel:"B2",usuario: 'dannita', password: 'carrillo', realname: 'dannitaaacarrilloo',img:'https://i.ibb.co/c3ZvTqW/My-english-bro-Logo-09.png'},

    ];
